<div class="si-theme si-reader-overlay" (click)="close()">
  <button type="button" class="si-modal-chevron si-modal-chevron--left" [disabled]="isFirstPage" (click)="$event.stopPropagation(); prev()">
    <img [src]="ICONS.CHEVRON_LEFT" alt="" />
  </button>

  <div class="si-reader-modal" (click)="$event.stopPropagation()">
    <div class="si-reader-modal__header">
      <div class="si-reader-modal__heading">
        <h3 class="si-reader-modal__title">{{ group?.contentTypeLabel }}</h3>
        <p class="si-reader-modal__subtitle">
          {{ "smart_import_showing_page" | translate: { page: pageIndex + 1, count: group?.pageNumbers?.length ?? 1 } }}
        </p>
      </div>
      <button type="button" class="si-reader-modal__close" (click)="close()">
        <img [src]="ICONS.CLOSE" alt="" /> {{ "close" | translate }}
      </button>
    </div>

    <div class="si-reader-modal__body">
      <div class="si-reader-modal__document">
        @if (fileUrl) {
          @if (viewerLoading) {
            <span class="si-viewer-loading">
              <span class="si-spinner"></span>
            </span>
          }
          <ngx-extended-pdf-viewer
            [src]="fileUrl"
            [page]="currentPageNumber"
            height="100%"
            class="w-100pc"
            [showToolbar]="false"
            [showSidebarButton]="false"
            [showFindButton]="false"
            [showPagingButtons]="false"
            [showZoomButtons]="true"
            [showPresentationModeButton]="false"
            [showOpenFileButton]="false"
            [showPrintButton]="false"
            [showDownloadButton]="false"
            [showBookmarkButton]="false"
            [showSecondaryToolbarButton]="false"
            [showRotateButton]="false"
            [showHandToolButton]="false"
            [showDrawEditor]="false"
            [showTextEditor]="false"
            (pdfLoadingStarts)="onViewerLoadingStarts()"
            (pdfLoaded)="onViewerLoaded()"
            (pageChange)="onViewerPageChange($event)"
          ></ngx-extended-pdf-viewer>
        }
      </div>
    </div>
  </div>

  <button type="button" class="si-modal-chevron si-modal-chevron--right" [disabled]="isLastPage" (click)="$event.stopPropagation(); next()">
    <img [src]="ICONS.CHEVRON_RIGHT" alt="" />
  </button>
</div>
